import { Logic } from '~common/ui-logic/logic'
import { executeTask, TaskState } from '~common/ui-logic/tasks'
import type { AppContextType } from '~/app-context'
import { debounce } from '~common/utils/debounce'

export interface SearchComponentLogicDependencies {
    initValue?: string
    initActive?: boolean
    onClick?: () => void
    onUpdate?: (query: string) => void
    dontDebounce?: boolean
}

export interface SearchComponentLogicState {
    loadState: TaskState
    searchQuery: string
    isActive: boolean
}

export class SearchComponentLogic extends Logic<
    SearchComponentLogicDependencies & AppContextType,
    SearchComponentLogicState
> {
    getInitialState = (): SearchComponentLogicState => ({
        loadState: 'pristine',
        searchQuery: this.deps.initValue || '',
        isActive: this.deps.initActive || true,
    })

    debouncedUpdate = debounce((query: string) => {
        this.deps.onUpdate?.(query)
    }, 300)

    async initialize() {
        await executeTask(this, 'loadState', async () => {
            // Component is ready to use
        })
    }

    handleSearchChange = (query: string) => {
        this.setState({ searchQuery: query })

        if (!this.deps.dontDebounce) {
            this.debouncedUpdate(query)
        } else {
            this.deps.onUpdate?.(query)
        }
    }

    handleFieldClick = () => {
        this.setState({ isActive: true })
        this.deps.onClick?.()
    }
}
